import { Button } from '../../../components/ui/button';
import { Plus } from 'lucide-react';

interface ManagementHeaderProps {
  onCreateNew: () => void;
}

export function ManagementHeader({ onCreateNew }: ManagementHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold">Practice Projects Management</h1>
        <p className="text-muted-foreground mt-1">
          Manage self-paced learning projects for students
        </p>
      </div>
      <Button onClick={onCreateNew} size="lg">
        <Plus className="w-5 h-5 mr-2" />
        Create New Project
      </Button>
    </div>
  );
}
